import MaterialDialogHeader from '../../../components/MaterialDialogHeader';
import { ComponentProps } from 'react';
import { ExternalMediaMedialinkH5P } from '../../../../../api/medialink';
import MaterialModal from './MaterialModal';
import { useTranslation } from 'react-i18next';

interface Props {
  id: string;
  headerProps: Pick<ComponentProps<typeof MaterialDialogHeader>, 'title' | 'tags' | 'titleTooltip'>;
  medialink: ExternalMediaMedialinkH5P;
}

function H5pModal({ headerProps, id, medialink }: Props) {
  const { t } = useTranslation();
  const fullWidth = !medialink.externalMedia.width && !medialink.externalMedia.height;

  return (
    <MaterialModal
      id={id}
      headerProps={headerProps}
      fullWidth={fullWidth}
      aria-label={t('PAGES.TOC_LEVEL.MODALS.H5P.A11Y_LABEL')}
    >
      <iframe
        role="presentation"
        src={`https://h5p.org/h5p/embed/${medialink.externalMedia.embedId}`}
        title={medialink.name}
        allow="fullscreen"
        width={medialink.externalMedia.width}
        height={medialink.externalMedia.height}
      />
    </MaterialModal>
  );
}

export default H5pModal;
